var swiper = new Swiper(".our-featured-slider", {
  loop: true,
  slidesPerView: 4,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1028: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    776: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    580: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
  },
});
